import { Globe, Link2, Tag } from "lucide-react";

const UTM_LABELS = {
  utm_source: "Origen",
  utm_medium: "Medio",
  utm_campaign: "Campaña",
  utm_term: "Término",
  utm_content: "Contenido",
};

export function LeadSourcePill({ source }) {
  if (source !== "public_form") return null;
  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-blue-50 text-blue-700">
      <Globe size={11} /> Formulario
    </span>
  );
}

function fmtDomain(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

export default function LeadSourceDetails({ source, metadata, submittedAt }) {
  if (source !== "public_form") return null;

  const meta = metadata || {};
  const utms = Object.keys(UTM_LABELS)
    .map((k) => ({ key: k, label: UTM_LABELS[k], value: meta[k] }))
    .filter((u) => u.value);

  const referrer = meta.referrer;

  return (
    <div className="rounded-lg border border-blue-100 bg-blue-50/40 p-3">
      <div className="flex items-center gap-2 text-blue-700 text-sm font-medium mb-2">
        <Globe size={14} />
        Lead recibido por tu formulario
      </div>

      {submittedAt && (
        <p className="text-xs text-gray-600 mb-2">
          Enviado el{" "}
          {new Date(submittedAt).toLocaleString("es-ES", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </p>
      )}

      {referrer && (
        <div className="flex items-center gap-1.5 text-xs text-gray-600 mb-2">
          <Link2 size={12} />
          <span className="truncate">Llegó desde {fmtDomain(referrer)}</span>
        </div>
      )}

      {utms.length > 0 ? (
        <div className="flex flex-wrap gap-1.5 mt-2">
          {utms.map((u) => (
            <span
              key={u.key}
              className="inline-flex items-center gap-1 px-2 py-0.5 text-xs rounded-md bg-white border border-blue-100 text-gray-700"
              title={u.key}
            >
              <Tag size={10} className="text-blue-500" />
              <span className="text-gray-500">{u.label}:</span>
              <span className="font-medium truncate max-w-[140px]">
                {u.value}
              </span>
            </span>
          ))}
        </div>
      ) : (
        !referrer && (
          <p className="text-xs text-gray-500">Sin datos de campaña.</p>
        )
      )}
    </div>
  );
}
